/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GenerateReportResponse } from './GenerateReportResponse';
import {
    GenerateReportResponseFromJSON,
    GenerateReportResponseFromJSONTyped,
    GenerateReportResponseToJSON,
    GenerateReportResponseToJSONTyped,
} from './GenerateReportResponse';

/**
 * 
 * @export
 * @interface GenerateReport200Response
 */
export interface GenerateReport200Response {
    /**
     * 
     */
    data?: GenerateReportResponse;
}

/**
 * Check if a given object implements the GenerateReport200Response interface.
 */
export function instanceOfGenerateReport200Response(value: object): value is GenerateReport200Response {
    return true;
}

export function GenerateReport200ResponseFromJSON(json: any): GenerateReport200Response {
    return GenerateReport200ResponseFromJSONTyped(json, false);
}

export function GenerateReport200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateReport200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : GenerateReportResponseFromJSON(json['data']),
    };
}

export function GenerateReport200ResponseToJSON(json: any): GenerateReport200Response {
    return GenerateReport200ResponseToJSONTyped(json, false);
}

export function GenerateReport200ResponseToJSONTyped(value?: GenerateReport200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': GenerateReportResponseToJSON(value['data']),
    };
}

